import { Item, Quest, QuestWalkthroughPiece, Skill } from "gamedata/GameData";
import { LoaderPageQuest } from "~/routes/__site/quests/$questId.$";

type DataType = "item" | "skill" | "quest";

function getNumberFromType(type: DataType): number {
  const typeMapping = { item: 11, skill: 22, quest: 33 };
  return typeMapping[type];
}

// Функция кодирования целых чисел
function encodeInt(props: {
  value: number;
  datatype: DataType;
  key?: string;
  uname: string;
  id?: number;
}): number {
  // Дополнительное кодирование
  const sId = props.id ?? 0;
  const sKey = (props.key ?? "huy").length * 3;
  const sUname = props.uname.length * 2;
  const sType = getNumberFromType(props.datatype) * 4;

  const sum = props.value + sType + sUname + sId + sKey;
  return sum ^ (sUname + sType);
}

// Функция декодирования целых чисел
export function decodeInt(props: {
  value: number;
  datatype: DataType;
  key?: string;
  uname: string;
  id?: number;
}): number {
  // Обратные операции для декодирования
  const sId = props.id ?? 0;
  const sKey = (props.key ?? "huy").length * 3;
  const sUname = props.uname.length * 2;
  const sType = getNumberFromType(props.datatype) * 4;

  const xor = props.value ^ (sUname + sType);
  return xor - sType - sUname - sId - sKey;
}

// Основная функция для обработки массива QuestWalkthroughPiece
function processQuestWalkthroughEncode(
  pieces: QuestWalkthroughPiece[]
): QuestWalkthroughPiece[] {
  return pieces.map((piece) => {
    if (typeof piece === "string") {
      return piece; // Оставляем строки без изменений
    } else if (piece.t === "item") {
      // Изменяем поле count для объектов типа item
      return {
        ...piece,
        count: encodeInt({
          value: piece.count ?? 0,
          datatype: "quest",
          uname: piece.id,
        }), // Используем длину id как seed для encodeInt
      };
    } else if (piece.t === "exp") {
      // Декодируем поле count для объектов типа item
      return {
        ...piece,
        exp: encodeInt({
          value: piece.exp ?? 0,
          datatype: "quest",
          uname: "exp",
        }),
      };
    } else if (piece.t === "sp") {
      // Декодируем поле count для объектов типа item
      return {
        ...piece,
        sp: encodeInt({
          value: piece.sp ?? 0,
          datatype: "quest",
          uname: "sp",
        }),
      };
    }
    // Оставляем другие объекты без изменений
    return piece;
  });
}

function processQuestWalkthroughDecode(
  pieces: QuestWalkthroughPiece[]
): QuestWalkthroughPiece[] {
  return pieces.map((piece) => {
    if (typeof piece === "string") {
      return piece; // Строки остаются без изменений
    } else if (piece.t === "item") {
      // Декодируем поле count для объектов типа item
      return {
        ...piece,
        count: decodeInt({
          value: piece.count ?? 0,
          datatype: "quest",
          uname: piece.id,
        }),
      };
    } else if (piece.t === "exp") {
      // Декодируем поле count для объектов типа item
      return {
        ...piece,
        exp: decodeInt({
          value: piece.exp ?? 0,
          datatype: "quest",
          uname: "exp",
        }),
      };
    } else if (piece.t === "sp") {
      // Декодируем поле count для объектов типа item
      return {
        ...piece,
        sp: decodeInt({
          value: piece.sp ?? 0,
          datatype: "quest",
          uname: "sp",
        }),
      };
    }
    // Оставляем другие объекты без изменений
    return piece;
  });
}

export function encodeQuest(data: Quest) {
  data.walkthrough.en = data.walkthrough.en.map((w) => ({
    ...w,
    pieces: processQuestWalkthroughEncode(w.pieces),
  }));

  data.walkthrough.ru = data.walkthrough.ru.map((w) => ({
    ...w,
    pieces: processQuestWalkthroughEncode(w.pieces),
  }));

  return data;
}
